import { z } from 'zod';

/** Teto de pessoas que um solicitante acompanha. */
export const REQUESTED_FOLLOWS_MAX = 50;

/** Teto de sugestões de quem passar a acompanhar. */
export const REQUESTED_FOLLOW_SUGGESTIONS_MAX = 10;

/** `/me.requestedFollow`: a tela de acompanhados liberada. Só existe quando libera. */
export const RequestedFollowEntrySchema = z.object({ allowed: z.literal(true) }).strict();
export type RequestedFollowEntry = z.infer<typeof RequestedFollowEntrySchema>;

/** Uma pessoa acompanhada ou sugerida. `id` é o publicId do viajante. */
export const RequestedFollowPersonSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    photoUrl: z.url().nullable().optional(),
  })
  .strict();
export type RequestedFollowPerson = z.infer<typeof RequestedFollowPersonSchema>;

/** `GET /requested-follows`: quem ela acompanha e quem sugerimos acompanhar. */
export const RequestedFollowsViewSchema = z
  .object({
    following: z.array(
      z.object({
        traveler: RequestedFollowPersonSchema,
        since: z.iso.datetime({ offset: true }),
      }),
    ),
    suggestions: z.array(
      z.object({
        traveler: RequestedFollowPersonSchema,
        /** Viagens que ela já pediu para essa pessoa (mínimo 1). */
        requestCount: z.number().int().min(1),
      }),
    ),
    max: z.number().int(),
  })
  .strict();
export type RequestedFollowsView = z.infer<typeof RequestedFollowsViewSchema>;

/** `POST /requested-follows`: `travelerId` é o publicId ou o id do roster. */
export const FollowTravelerBodySchema = z.object({ travelerId: z.string().min(1) }).strict();
export type FollowTravelerBody = z.infer<typeof FollowTravelerBodySchema>;
